module.exports = __webpack_public_path__ + "img/loading-val.9bd87419.svg";